import FormFooter from './form-footer';

export default FormFooter;
